module.exports = __webpack_public_path__ + "static/media/insights-logo.19a55ab3.svg";